<div class="modal fade" id="addUserModal" msEscClose (escPressed)="onCancelRequested()"
    data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header border-0 p-4">
                <h5 class="modal-title">Add User</h5>
            </div>
            <div class="modal-body text-center">
                <ms-add-user-form (submissionResult)="onAddUserResult($event)" (cancelRequested)="onCancelRequested()">
                </ms-add-user-form>
            </div>
        </div>
    </div>
</div>

<ms-confirmation-modal #userFormConfirmationModalRef modalId="userFormConfirmationModal"
    confirmButtonText="Leave" cancelButtonText="Stay"
    (confirmed)="confirmationConfirmFunction()"
    (cancelled)="confirmationCancelFunction()"
/>

<ms-info-modal #userFormInfoModalRef modalId="userFormInfoModal" (onConfirm)="infoModalConfirmed()" />